
import { Component, Vue} from 'vue-property-decorator';
import { SessionManager } from "@/components/utils/utils";
import { namespace } from "vuex-class";   

import "@/store/modules/common";
const commonState = namespace("Common");


@Component
export default class NavigationTopbar extends Vue {
    
    @commonState.Action
    public UpdateHideHeaderFooter!: (newHideHeaderFooter) => void

    error = "";

    @commonState.State
    public userName!: string;  

    public logout(isQuickExit) {

        const emptyApplicationRoutes = ["/", "/status", "/serviceLocator"];

        if (emptyApplicationRoutes.indexOf(this.$route.fullPath) == -1) {
            Vue.prototype.$saveChanges();
        }
        Vue.nextTick().then(() => {
            if (isQuickExit){
                window.open('http://www.google.ca');
                SessionManager.logoutAndRedirect(this.$store);
            }else 
                SessionManager.logout(this.$store);
        });
    }

    public runsurvey(){
        this.UpdateHideHeaderFooter(true)
        this.$router.push({name: "surveyeditor"})
    }

    public viewStatus() {
        if(this.$route.name != "applicant-status")
            this.$router.push({ name: "applicant-status" });
    }

    public isDevEnv(){
        const host = window.location.host;
        const DEV = ['0.0.0.0', 'localhost', 'dev.'];   

        return (DEV.some(s=>host.indexOf(s) > -1))
    }

};
